import { render } from "./services-list.vue?vue&type=template&id=df972596"
import script from "./services-list.vue?vue&type=script&lang=js"
export * from "./services-list.vue?vue&type=script&lang=js"

import "./services-list.vue?vue&type=style&index=0&id=df972596&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__